module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.folder.name))])]), _vm._v(" "), _c('edit-folder-modal', {
    attrs: {
      "folderId": _vm.folderId
    }
  }), _vm._v(" "), _c('move-folder-modal', {
    attrs: {
      "folder": _vm.folder
    }
  }), _vm._v(" "), _c('delete-folder-modal', {
    attrs: {
      "folderId": _vm.folderId
    }
  }), _vm._v(" "), _c('create-requirement-modal', {
    attrs: {
      "parentFolderId": _vm.folderId,
      "modalId": "create-requirement-modal-FolderDetail"
    }
  }), _vm._v(" "), _c('create-folder-modal', {
    attrs: {
      "parentFolderId": _vm.folderId,
      "modalId": "create-folder-modal-FolderDetail"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-view-buttons"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.edit-folder-modal",
      modifiers: {
        "edit-folder-modal": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "size": "sm"
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  }), _vm._v("\n      Edit\n    ")], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.move-folder-modal",
      modifiers: {
        "move-folder-modal": true
      }
    }],
    attrs: {
      "variant": "warning",
      "size": "sm"
    }
  }, [_vm._v("\n      Move\n    ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.delete-folder-modal",
      modifiers: {
        "delete-folder-modal": true
      }
    }],
    attrs: {
      "variant": "danger",
      "size": "sm"
    }
  }, [_vm._v("\n      Delete\n    ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.create-requirement-modal-FolderDetail",
      modifiers: {
        "create-requirement-modal-FolderDetail": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "size": "sm"
    }
  }, [_vm._v("\n      Create a requirement in this folder\n    ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.create-folder-modal-FolderDetail",
      modifiers: {
        "create-folder-modal-FolderDetail": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "size": "sm"
    }
  }, [_vm._v("\n      Create a child folder\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-539dd893"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FolderDetail.vue
// module id = 1012
// module chunks = 1